import gql from 'graphql-tag';

export const FULL_PLEX_USER_RELATION_FRAGMENT = gql`
  fragment fullPlexUserRelation on PlexUserRelation {
    id
    role
    state
  }
`;
